<template>
  <div id="app">
    <!--<div class="header"> <el-progress :percentage="percent" :show-text="false" :stroke-width="5"></el-progress> </div>-->
    <div class="container" ref="container">
      <div class="nav">
        <div class="nav-content">
          <div class="">
            <el-dropdown class="uhead">
              <span>
                <img src="assets/img/more.png" alt="" class="nav-menu" aria-hidden="true">
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><a href="/about_us.html" class="nav-menu-link">About Us</a></el-dropdown-item>
                <el-dropdown-item><a href="/cate_1_1.html" class="nav-menu-link">Hot Questions</a></el-dropdown-item>
                <el-dropdown-item><a href="/price.html" class="nav-menu-link">Price</a></el-dropdown-item>
                <el-dropdown-item><a href="/contact_us.html" class="nav-menu-link">Contact Us</a></el-dropdown-item>
                <el-dropdown-item><a href="/privacy_terms.html" class="nav-menu-link">Privacy Terms</a></el-dropdown-item>
                <el-dropdown-item><a href="/service_agreement.html" class="nav-menu-link">Service Agreement</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="nav-menus">
              <a class="nav-menu-item" href="/about_us.html"> About Us </a>
              <a class="nav-menu-item" href="/cate_1_1.html"> Hot Questions </a>
              <a class="nav-menu-item" href="/price.html"> Price </a>
              <a class="nav-menu-item" href="/contact_us.html"> Contact Us </a>
            </div>
          </div>
          <div class="nav-op">
            <span v-if="uid != ''">
              <el-dropdown trigger="click" @command="redirectUrl">
                <span class="nav-uinfo" aria-haspopup="list" aria-controls="dropdown-menu-4545" role="button" tabindex="0">
                  Hi, {{ user_name }} 
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="account">Account</el-dropdown-item>
                  <el-dropdown-item command="logout">Logout</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <a class="nav-btn-login" v-if="uid == ''" href="/login.html"> Log in </a>
            <a class="nav-btn" v-if="uid == ''" href="/register.html"> Sign up </a>
          </div>
          <div class="nav-op2" v-if="uid == ''">
            <el-dropdown class="uhead">
              <span aria-haspopup="list" aria-controls="dropdown-menu-5194" role="button" tabindex="0">
                <img src="assets/img/uhead-icon.png" alt="" class="nav-menu">
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><a href="/login.html" class="nav-menu-link">Log in</a></el-dropdown-item>
                <el-dropdown-item><a href="/register.html" class="nav-menu-link">Sign up</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

        </div>
      </div>

      <div class="form">
        <div class="form-content">
          <div class="form-top">
            <img src="assets/img/logo2.jpg" alt="" class="site-logo" fetchpriority="high" />
          </div>
          <div class="form-mid">
            <el-input
              id="ask-content"
              placeholder-class="form-textarea-placeholder"
              type="textarea"
              :autofocus="true"
              :resize="false"
              :rows="rows"
              minlength="12"
              placeholder="Anything you want to know about China travel, such as visa, destination, travel guide, transportation, accommodation, local foods .ect"
              v-model="content">
            </el-input>
            <img src="assets/img/ask-btn.png" alt="" class="ask-btn" @click="askQuestion">
          </div>
          <div class="form-bottom">
            <label class="form-bottom-label"> We offer 24/7 professional online consultation services to assist you in resolving any inguiries regardingtraveling to China, such as visa matters, safety concerns, itinerary plan, travel quides, transportation,hotel, local food,internet access,exchange rates .etc </label>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="footer-content">
          <div class="footer-left">
            <a href="/privacy_terms.html" class="footer-left-text"> Privacy Terms </a>
            <a href="/service_agreement.html" class="footer-left-text"> Service Agreement </a>
          </div>
          <div class="footer-right">
            <label class="footer-right-text"> ©2025 China Travel Ask </label>
          </div>  
        </div>
        <div class="h5-footer-content">
          <label class="footer-right-text"> ©2025 China Travel Ask </label>
        </div>  
      </div>

    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import storage from 'good-storage'
  import { postRequest } from '@/utils/Common';
  export default {
    name: 'App',
    data() {
      return {
        percent: 0,
        session_id: '',
        uid: '',
        user_info: null,
        user_name: '',
        content: '',
        lock: 0,
        loadingCanceled: false,
        rows: 6,
        animationFrameId: null
      }
    },
	  mounted(){
      if(this.isMobile()){
        this.rows = 6;
      }
      var session_id = sessionStorage.getItem("session_id");
      if(!session_id){
        session_id = Date.now();
        sessionStorage.setItem("session_id", session_id);
      }
      this.session_id = session_id;
      if(this.isLogin()){
        this.getUserInfo();
      }
      this.visitLog();
    },
    methods: {
      isMobile() {
        const mobileMaxWidth = 768; 
        return window.innerWidth <= mobileMaxWidth;
      },
      async visitLog(){
        let formData = {
          session_id: this.session_id,
          uid: this.uid,
          path: '/index.html',
          params: ''
        }
        try {
          const response = await postRequest('/add_visit_log', formData);
          console.log(response);
        } catch (error) {
          console.log(error);
        }
      },
      toLogin(){
        window.location.href = '/login.html';
      },
      isLogin(){
        if (!storage.has("c_u_uid")){
          return false;
        }
        let uid = storage.get('c_u_uid');
        this.uid = uid;
        console.log(this.uid);
        return true;
      },
      async getUserInfo(){
        let formData = {
          session_id: this.session_id,
          id: this.uid
        }
        try {
          const response = await postRequest('/get_user_info', formData);
          this.user_info = response;
          this.formatUserInfo();
          return response;
        } catch (error) {
          console.error('user info get error: ', error);
          return null;
        }
      },
      formatUserInfo(){
        if(this.user_info){
          let user_info = this.user_info;
          if(user_info.username != ''){
            this.user_name = user_info.username;
          }
          else{
            this.user_name = user_info.email;
          }
        }
      },
      redirectUrl(command){
        console.log(command);
        if(command == 'account'){
          this.toAccount();
        }
        else if(command == 'logout'){
          this.logout();
        }
      },
      toAccount(){
        window.location.href = '/person_info.html';
      },
      logout(){
        storage.remove('c_u_uid');
        window.location.href = '/index.html';
      },
      toRegister(){
        window.location.href = '/register.html';
      },
      toLogin(){
        window.location.href = '/login.html';
      },
      async askQuestion(){
        let filteredContent = this.content.replace(/[\s\p{P}\p{S}]/gu, '');
        if (filteredContent == ''){
          alert('Please enter your question');
          return;
        }
        if (filteredContent.length < 10) {
          alert('Please enter a meaningful question.');
          return;
        }
        if (this.lock == 1){
          alert('Please wait for the previous question to be answered');
          return;
        }
        this.lock = 1;
        if (typeof gtag !== 'undefined') {
          gtag('event', 'do_ask', {});
        }
        //this.showLoading();
        let formData = {
          session_id: this.session_id,
          uid: this.uid,
          content: this.content
        }
        try {
          const response = await postRequest('/pre_ask', formData);
          console.log('提交结果:', response);
          //this.lock = 0;
          //this.completeLoading();
          window.location.href = '/chat.html?sno=' + response.sno;
        } catch (error) {
          console.error('提交失败:', error);
          //this.cancelLoading();
          this.lock = 0;
          alert(error);
        }
      },
      showLoading(){
        const totalDuration = 90000; // 总时长90秒(毫秒)
        const intervals = [
          {start: 0, end: 30, duration: 15000}, // 0-30 15秒完成
          {start: 30, end: 60, duration: 30000}, // 30-60 30秒完成
          {start: 60, end: 90, duration: 30000}, // 60-90 30秒完成
          {start: 90, end: 100, duration: 15000} // 90-100 15秒完成
        ];
        let currentInterval = 0;
        let startTime = Date.now();
        const updateProgress = () => {
          if(this.loadingCanceled) {
            cancelAnimationFrame(this.animationFrameId);
            return;
          }

          const now = Date.now();
          const elapsed = now - startTime;
          const interval = intervals[currentInterval];
          
          if (elapsed >= interval.duration) {
            this.percent = interval.end;
            startTime = now;
            currentInterval++;
            if (currentInterval >= intervals.length) {
              return; // 所有区间已完成
            }
          } else {
            const progress = (elapsed / interval.duration) * (interval.end - interval.start);
            this.percent = Math.min(interval.start + progress, interval.end);
          }
          if (this.percent < 100) {
            this.animationFrameId = requestAnimationFrame(updateProgress);
          }
        };
        updateProgress();
      },
      cancelLoading() {
        this.loadingCanceled = true;
        if(this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
        }
        this.percent = 0; // 可选：重置进度条
        this.lock = 0; // 解锁
      },
      completeLoading() {
        this.percent = 100;
      }

    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
	  width: 100%;
    height: 100vh;
    margin: 0 auto;
    padding: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .header {
    width: 100%;
    height: 5px;
    margin: 0;
    padding: 0;
  }
  .container {
    background: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
  }

  .nav {
    width: 96%;
    padding: 5px 0 3px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
  }

  .nav-content {
    border-radius: 5px;
    width: 96%;
    margin: 0 auto;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .uhead{
    display: none;
  }

  .nav-menus {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .nav-menu-item {
    font-size: 18px;
    line-height: 28px;
    vertical-align: middle;
    color: #038b43;
    margin: 0 20px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
    position: relative;
  }

  .nav-menu-item::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;                /* 初始宽度为0 */
    height: 2px;
    background: #038b43;
    transition: width 0.3s;  /* 动画过渡 */
  }

  .nav-menu-item:hover::after {
    width: 100%;            /* 悬停时宽度变为100% */
  }

  .nav-menu{
    display: none;
    width: 30px;
    height: auto;
    cursor: pointer;
  }

  .nav-op{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .nav-op2{
    display: none;
  }

  .nav-btn-login{
    display: inline-block;
    font-size: 14px;
    border: #038b43 solid 1px;
    color: #038b43;
    width: 75px;
    height: 28px;
    border-radius: 12px;
    text-align: center;
    line-height: 28px;
    vertical-align: middle;
    cursor: pointer;
    text-decoration: none;
  }

  .nav-btn{
    display: inline-block;
    font-size: 14px;
    border: #038b43 solid 1px;
    background: #038b43;
    color: #fff;
    width: 75px;
    height: 28px;
    border-radius: 12px;
    text-align: center;
    line-height: 28px;
    vertical-align: middle;
    margin-left: 12px;
    cursor: pointer;
    text-decoration: none;
  }

  .nav-uinfo{
    font-size: 16px;
    line-height: 28px;
    vertical-align: middle;
    font-weight: bold;
    cursor: pointer;
  }

  .form {
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 15px 0 30px;
  }

  .form-content {
    height: 100%;
    width: 65%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  .form-top {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }

  .site-logo {
    width: 50%;
    max-width: 350px;
    height: auto;
  }

  .form-mid {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /*margin-top: 60px;*/
    position: relative;
  }

  .form-textarea{
    width: 100%;
    min-height: 140px;
    border: #ccc solid 1px;
    background: #f1f1f1;
    color: #333;
    font-size: 16px;
    border-radius: 6px;
    line-height: 24px;
    padding: 8px;
    font-family: Arial,sans-serif;
  }

  .form-textarea-placeholder {
    color: #999;
    font-size: 16px;
    line-height: 24px;
    font-family: Arial,sans-serif;
    font-weight: bold;
  }

  .ask-btn{
    display: block;
    width: 80px;
    z-index: 999;
    position: absolute;
    right: 15px;
    bottom: 15px;
    cursor: pointer;
    transform: translateY(0);
  }

  .form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /*margin-top: 60px;*/
  }

  .form-bottom-label {
    color: #333;
    font-size: 15px;
    line-height: 30px;
    text-align: center;
  }

 .footer {
    width: 100%;
    height: 50px;
    background: #eee;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 55px;
  }

  .footer-content {
    width: 94%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .h5-footer-content{
    display: none;
  }

  .footer-left {
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .footer-left-text {
    color: #333;
    font-size: 13px;
    margin: 0 20px;
    text-decoration: none;
  }

  .footer-right {
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .footer-right-text {
    color: #333;
    font-size: 13px;
    margin: 0 20px;
    text-decoration: none;
  }

  #ask-content {
    background: #fafafa;
    color: #333;
    border-radius: 12px;
    padding: 10px 15px 10px 15px;
    font-family: Arial,sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .uhead {
      display: block;
    }

    .nav-menus {
      display: none;
    }

    .nav-op2{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }

    .nav-menu{
      display: block;
      width: 30px;
      height: auto;
      cursor: pointer;
    }

    .nav-menu-link{
      color: #666;
      font-size: 14px;
      text-decoration: none;
    }

    .nav-btn-login,.nav-btn {
      display: none;
    }

    .form-content {
      width: 90%;
    }

    .site-logo {
      width: 80%;
    }

    .form-bottom-label {
      color: #333;
      font-size: 13px;
      line-height: 26px;
      text-align: center;
    }

    .footer-content{
      display: none;
    }

    .form-textarea-placeholder {
      color: #999;
      font-size: 14px;
      line-height: 21px;
      font-family: Arial,sans-serif;
      font-weight: bold;
    }

    #ask-content {
      resize: none;
      background: #fafafa;
      color: #333;
      border-radius: 12px;
      padding: 10px 15px 10px 15px;
      font-family: Arial,sans-serif;
      font-size: 14px;
      line-height: 21px;
      font-weight: bold;
      min-height: 185px;
    }

    .h5-footer-content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .footer-right-text {
      color: #333;
      font-size: 12px;
      margin: 0 20px;
      text-decoration: none;
    }

  }


</style>